export default __webpack_public_path__ + "static/media/spinning-job-work.0f755bb7.png";